// extracted by mini-css-extract-plugin
export default {"cartbar":"CartBar_cartbar__eBKBE","priceBox":"CartBar_priceBox__PJNbg","totalCost":"CartBar_totalCost__4k5uP"};